<template>
  <div>
    <Form
      style="margin: 30px 20px"
      :model="formItem"
      :label-width="135"
      label-position="left"
    >
      <Row>
        <Col :md="3" :xs="24">
          <div class="photoava">
            <img
              v-if="formItem.portrait"
              :src="'data:image/jpeg;base64,' + formItem.portrait || ''"
              alt=""
            />
            <span v-if="!formItem.portrait">暂无照片</span>
          </div>
        </Col>
        <Col :md="21" :xs="24">
          <Row :gutter="16">
            <Col :md="8" :xs="24">
              <FormItem label="员工姓名">
                <Input v-model="formItem.empcode" disabled readonly />
              </FormItem>
            </Col>
            <Col :md="8" :xs="24">
              <FormItem label="岗位名称">
                <Input v-model="formItem.empcode" disabled readonly />
              </FormItem>
            </Col>
            <Col :md="8" :xs="24">
              <FormItem label="直线经理">
                <Input v-model="formItem.empcode" disabled readonly />
              </FormItem>
            </Col>
            <Col :md="8" :xs="24">
              <FormItem label="国籍">
                <Input v-model="formItem.empcode" disabled readonly />
              </FormItem>
            </Col>
            <Col :md="8" :xs="24">
              <FormItem label="职级">
                <Input v-model="formItem.empcode" disabled readonly />
              </FormItem>
            </Col>
            <Col :md="8" :xs="24">
              <FormItem label="虚线经理">
                <Input v-model="formItem.empcode" disabled readonly />
              </FormItem>
            </Col>
            <Col :md="8" :xs="24">
              <FormItem label="生日">
                <Input v-model="formItem.empcode" disabled readonly />
              </FormItem>
            </Col>
            <Col :md="8" :xs="24">
              <FormItem label="职能">
                <Input v-model="formItem.empcode" disabled readonly />
              </FormItem>
            </Col>
            <Col :md="8" :xs="24">
              <FormItem label="嘉士伯开始时间">
                <Input v-model="formItem.empcode" disabled readonly />
              </FormItem>
            </Col>
            <Col :md="8" :xs="24">
              <FormItem label="工作地">
                <Input v-model="formItem.empcode" disabled readonly />
              </FormItem>
            </Col>
            <Col :md="8" :xs="24">
              <FormItem label="本岗位开始时间">
                <Input v-model="formItem.empcode" disabled readonly />
              </FormItem>
            </Col>
            <Col :md="8" :xs="24">
              <FormItem label="语言">
                <Input v-model="formItem.empcode" disabled readonly />
              </FormItem>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row :gutter="16">
        <Col :md="8" :xs="24">
          <FormItem label="是否有能动性">
            <Input v-model="formItem.empcode" disabled readonly />
          </FormItem>
        </Col>
        <Col :md="8" :xs="24">
          <FormItem label="跨地域">
            <Input v-model="formItem.empcode" disabled readonly />
          </FormItem>
        </Col>
        <Col :md="8" :xs="24">
          <FormItem label="跨职能">
            <Input v-model="formItem.empcode" disabled readonly />
          </FormItem>
        </Col>
        <Col :md="24" :xs="24">
          <FormItem label="能动性具体说明">
            <Input
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 5 }"
              v-model="formItem.empcode"
              disabled
              readonly
            />
          </FormItem>
        </Col>
        <Col :md="8" :xs="24">
          <FormItem label="下一岗位的准备度">
            <Select v-model="formItem.code4">
              <Option
                v-for="item in list1"
                :value="item.value"
                :key="item.value"
                >{{ item.label }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :md="8" :xs="24">
          <FormItem label="业务可释放时间">
            <Select v-model="formItem.code4">
              <Option
                v-for="item in list2"
                :value="item.value"
                :key="item.value"
                >{{ item.label }}</Option
              >
            </Select>
          </FormItem>
        </Col>
      </Row>
    </Form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      formItem: {},
      list1: [],
      list2: []
    };
  }
};
</script>
<style lang="less" scoped>
.photoava {
  margin-right: 4%;
  height: 220px;
  width: 150px;
  margin-bottom: 20px;
  img {
    height: 220px;
    width: 150px;
    border: #084d92 1px solid;
  }
  span {
    height: 220px;
    width: 150px;
    border: #084d92 1px solid;
    text-align: center;
    line-height: 150px;
    -webkit-writing-mode: vertical-rl;
    writing-mode: vertical-rl;
  }
  div {
    display: flex;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/process/MyQuery/teamInfoComponents/tabPane1Info.vue